// extracted by mini-css-extract-plugin
export default {"imagePreview":"AnswerImage_imagePreview__Ql6+W","imagePreviewOverlay":"AnswerImage_imagePreviewOverlay__UZjkm","moreMenuButton":"AnswerImage_moreMenuButton__UqeUa"};